/**
 * MosaicBucketBadge.js — v6.38.0 (WIDA 6-level parity)
 * Compact level badge shared across MOSAIC UI surfaces.
 */
import React from 'react';

const LEVEL_TO_TAILWIND = {
  1: { bg: 'bg-rose-100',    border: 'border-rose-300',    text: 'text-rose-800',    dot: 'bg-rose-500' },
  2: { bg: 'bg-orange-100',  border: 'border-orange-300',  text: 'text-orange-800',  dot: 'bg-orange-500' },
  3: { bg: 'bg-amber-100',   border: 'border-amber-300',   text: 'text-amber-800',   dot: 'bg-amber-500' },
  4: { bg: 'bg-emerald-100', border: 'border-emerald-300', text: 'text-emerald-800', dot: 'bg-emerald-500' },
  5: { bg: 'bg-blue-100',    border: 'border-blue-300',    text: 'text-blue-800',    dot: 'bg-blue-500' },
  6: { bg: 'bg-indigo-100',  border: 'border-indigo-300',  text: 'text-indigo-800',  dot: 'bg-indigo-500' },
};

const MosaicBucketBadge = ({ level, label, compact = false }) => {
  const lvl = Math.max(1, Math.min(6, Number(level) || 1));
  const colors = LEVEL_TO_TAILWIND[lvl];
  return (
    <span
      data-testid={`mosaic-bucket-badge-${lvl}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 border ${colors.bg} ${colors.border} ${colors.text} ${
        compact ? 'text-[11px]' : 'text-xs'
      } font-bold tracking-wide uppercase`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
      <span>L{lvl}</span>
      {label ? <span className="normal-case font-semibold">· {label}</span> : null}
    </span>
  );
};

export default MosaicBucketBadge;
